/* unplugin-vue-components disabled */import { render } from "./recommondPoster.vue?vue&type=template&id=2a470a3e&scoped=true"
import script from "./recommondPoster.vue?vue&type=script&lang=js"
export * from "./recommondPoster.vue?vue&type=script&lang=js"

import "./recommondPoster.vue?vue&type=style&index=0&id=2a470a3e&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a470a3e"]])

export default __exports__